import { createAction, handleActions } from "redux-actions";
import { axios } from "@cores/axiosWrapper";

function getAgreementsAPI(stageId, apiEndpoint, params) {
    const headers = {
        stageId,
    };
    return axios.get(`${apiEndpoint}/agreements`, {
        params,
        headers,
    });
}

function getUserAgreementAPI(stageId, apiEndpoint, id, params) {
    const headers = {
        stageId,
    };

    return axios.get(`${apiEndpoint}/user-agreements/${id}`, {
        params,
        headers,
    });
}

function updateUserAgreementAPI(stageId, apiEndpoint, id, params) {
    const headers = {
        stageId,
    };
    return axios.post(`${apiEndpoint}/user-agreements/${id}/actions`, params, {
        headers,
    });
}

const initialState = {
    data: null,
    pending: false,
    error: false,
    detail: null,
};

const GET_AGREEMENTS_SUCCESS = "GET_AGREEMENTS_SUCCESS";
const GET_USER_AGREEMENT_PENDING = "GET_USER_AGREEMENT_PENDING";
const GET_USER_AGREEMENT_SUCCESS = "GET_USER_AGREEMENT_SUCCESS";
const GET_USER_AGREEMENT_FAILURE = "GET_USER_AGREEMENT_FAILURE";
const RESET_USER_AGREEMENT = "RESET_USER_AGREEMENT";

export default handleActions(
    {
        [GET_AGREEMENTS_SUCCESS]: (state, action) => {
            return { ...state, data: action.payload, pending: false };
        },
        [GET_USER_AGREEMENT_PENDING]: (state) => {
            return { ...state, pending: true, data: null, error: false };
        },
        [GET_USER_AGREEMENT_SUCCESS]: (state, action) => {
            return { ...state, detail: action.payload, pending: false };
        },
        [GET_USER_AGREEMENT_FAILURE]: (state, action) => {
            return { ...state, pending: false, error: action.payload };
        },
        [RESET_USER_AGREEMENT]: (state) => {
            return { ...initialState };
        },
    },
    initialState,
);

export const resetUserAgreement = createAction(RESET_USER_AGREEMENT);

export const getUserAgreements =
    ({ params }) =>
    async (dispatch, getState) => {
        let { stage } = getState();

        dispatch({ type: GET_USER_AGREEMENT_PENDING });
        try {
            let allResults = [];
            let nextToken = undefined;
            do {
                const response = await getAgreementsAPI(stage.id, stage.endpoint, {
                    ...params,
                    ...(nextToken ? { nextToken } : {}),
                });
                const results = response.data?.results || [];
                allResults = allResults.concat(results);
                nextToken = response.data?.nextToken;
            } while (nextToken);

            dispatch({
                type: GET_AGREEMENTS_SUCCESS,
                payload: allResults,
            });

            const id = allResults?.[0]?.id;
            if (!id) throw new Error("No user agreement found.");

            const userAgreement = await getUserAgreementAPI(stage.id, stage.endpoint, id, params);
            dispatch({
                type: GET_USER_AGREEMENT_SUCCESS,
                payload: userAgreement.data,
            });
            return userAgreement.data;
        } catch (error) {
            dispatch({
                type: GET_USER_AGREEMENT_FAILURE,
            });
            return error;
        }
    };

export const updateUserAgreement =
    ({ id, params }) =>
    (dispatch, getState) => {
        let { stage } = getState();
        return updateUserAgreementAPI(stage.id, stage.endpoint, id, params);
    };
